import React from "react";
import { ModalHeader, BoxStyle } from "assets/css/globle";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import { TopBox, ModalBody } from "pages/AdminDashboard/AdminDashboardStyled";
import PaceReport from "assets/images/pace-report-image.png";
import { useTranslation } from "react-i18next";
import { useRedirectToPage } from "commonComponents/Navigation";
import { CarBehindPace } from "../CarBehindPace/CarBehindPace";
import CarBehindPaceIcon from "assets/svgIcons/AdminDashboard/CarBehindPaceIcon";
import MapScreen from "assets/images/map-section.png";
import { Modal, Box } from "@mui/material";
import "./PaceReportModal.css";

export const PaceReportModal = ({
    openAlertModal,
    setOpenAlertModal,
    paceStats
}) => {
    const { t } = useTranslation();
    const redirectToPage = useRedirectToPage();

    return (
        <Modal
            open={openAlertModal}
            onClose={() => setOpenAlertModal(false)}
            aria-labelledby="pace-modal-title"
            aria-describedby="pace-modal-description"
        >
            <Box sx={{ ...BoxStyle, maxWidth: paceStats ? '60%' : '45%' }}>
                <ModalHeader className="modal-header">
                    <div className="header-section">
                        <h2>{paceStats ? t("Cars_Behind_Pace") : `${t("Fleet")}/${t("Cars")}`}</h2>
                    </div>
                    {paceStats && (
                        <div className="header-section">
                            <h2>{t("Map") + "/" + t("Cars")}</h2>
                        </div>
                    )}
                    <div className="header-section">
                        <h2>{t("Live_Pace")}</h2>
                    </div>
                    <div className="close-button">
                        <ModalCloseIcon onClick={() => setOpenAlertModal(false)} />
                    </div>
                </ModalHeader>

                <ModalBody className="modal-body">
                    {paceStats ? (
                        <>
                            <CarBehindPace carsBehindPace={(paceStats?.warning || 0) + (paceStats?.critical || 0)} />
                            <TopBox noAfter>
                                <div className="box-body" onClick={() => redirectToPage("map")}>
                                    <img src={MapScreen} alt="Map/Cars" className="map-image" />
                                </div>
                            </TopBox>
                            <TopBox noAfter>
                                <div className="box-body" onClick={() => redirectToPage("dashPace")}>
                                    <img src={PaceReport} alt="pace-report" className="image" />
                                </div>
                            </TopBox>
                        </>
                    ) : (
                        <>
                            <TopBox noAfter>
                                <div className="box-body" onClick={() => redirectToPage("pre-round")}>
                                    <CarBehindPaceIcon width={200} height={200} fill={"none"} />
                                </div>
                            </TopBox>
                            <TopBox noAfter>
                                <div className="box-body" onClick={() => redirectToPage("dashPace")}>
                                    <img src={PaceReport} alt="pace-report" className="image" />
                                </div>
                            </TopBox>
                        </>
                    )}
                </ModalBody>
            </Box>
        </Modal>
    );
};